<template>
  <div>
      <convert-file fileType="corsa" fileTitle="For Carnival Alice, My-2K, MRTAXI, Navi and Corsa"/>
      <convert-file fileType="arga" fileTitle="For Carnival Alice grid animation effect"/>
      <convert-file fileType="abkg" fileTitle="For Meta background"/>
      <convert-file fileType="asts" fileTitle="For Meta status"/>
      <convert-file fileType="small" fileTitle="For Meta right screen ,8xv3.0 and Vita Classic"/>
      <convert-file fileType="auxi" fileTitle="For Meta up left screen and Vita down screen"/>
      <convert-file fileType="anim" fileTitle="For Vita up screen"/>
      <convert-file fileType="amft" fileTitle="For font customization"/>
      <convert-file fileType="abkg_big" fileTitle="For Testing"/>
  </div>
</template>

<script>
import ConvertFile from "./ConvertFile.vue";

export default {
  name: "upload-files",
  components: {
      'convert-file' : ConvertFile
  }
};
</script>
